import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAutomationTemplateStepOpportunityCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IOpportunityAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			templateId,
			step,
			beforeId,
			impersonationContext,
		}: {
			templateId: string;
			step: Api.IOpportunityAutomationStep;
			beforeId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IOpportunityAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Opportunity`,
					queryParams: beforeId ? { beforeId } : undefined,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess,
	});
}
